import {
  DesignChannelType,
  DesignChannelName
} from '../../types';

/**
 * Maps values from @see DesignChannelType to their matching values in @see DesignChannelName.
 *
 * Ideally we would get rid of @see DesignChannelName which makes this unnecessary, but that would require changes in PE as well.
 */
export const channelTypeToName: {
  [K in keyof(typeof DesignChannelType) as (typeof DesignChannelType)[K]]: (typeof DesignChannelName)[K];
} = {
  [DesignChannelType.email]: DesignChannelName.email,
  [DesignChannelType.facebook]: DesignChannelName.facebook,
  [DesignChannelType.instagram]: DesignChannelName.instagram,
  [DesignChannelType.mobile]: DesignChannelName.mobile,
  [DesignChannelType.other]: DesignChannelName.other,
  [DesignChannelType.sms]: DesignChannelName.sms,
  [DesignChannelType.socialChat]: DesignChannelName.socialChat,
  [DesignChannelType.twitter]: DesignChannelName.twitter,
  [DesignChannelType.voice]: DesignChannelName.voice,
  [DesignChannelType.webChat]: DesignChannelName.webChat,
  [DesignChannelType.whatsApp]: DesignChannelName.whatsApp
};
